import {Create_Document} from "./Types";

export const CreateDocument = (val) => {
  return {
    type: Create_Document,
    data: val,
  }
}